import Vue from 'vue'
import Router from 'vue-router'
import { RESERVATIONS_ENABLED } from '@/configure/index'
const title_suffix = "- Omni Center";
Vue.use(Router)

let router = new Router({
    mode: "history",
    routes: [
        /** ------------------- Dashboard ----------------------------- */
        {
            path: '/',
            component: () => import('@/components/pages/dashboard/Dashboard.vue'),
            meta: {
                title: 'Dashboard',
                layout: 'admin-layout',
                suffix: title_suffix
            }
        },
        /** ------------------- Router Apps ----------------------------- */
        {
            path: '/apps',
            name: 'apps-list',
            component:() => import('@/components/pages/apps/list/Index.vue'),
            meta: {
                title: 'App list',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App List'},
                ],
            }
        },
        {
            path: '/app_requests',
            name: 'app-request',
            component:() => import('@/components/pages/apps/request/Index.vue'),
            meta: {
                title: 'App Requests',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Requests'},
                ],
            }
        },
        {
            path: '/app_request/:id',
            name: 'app-request-detail',
            component: () => import('@/components/pages/apps/request/View.vue'),
            meta: {
                title: 'App Request detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Requests', link: '/app_requests' },
                    { name: 'App Request detail' }
                ],
            }
        },
        {
            path: '/app_pushes',
            name: 'app-pushes',
            component:() => import('@/components/pages/apps/pushes/Index.vue'),
            meta: {
                title: 'App Pushes',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Pushes', link: '/app_pushes'},
                ],
            }
        },
        {
            path: '/app_push/:id',
            name: 'app-push-detail',
            component:() => import('@/components/pages/apps/pushes/View.vue'),
            meta: {
                title: 'App Push detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Pushes', link: '/app_pushes' },
                    { name: 'App Pushes detail' }
                ],
            }
        },
        {
            path: '/app_platform_requests',
            name: 'app-platform-requests',
            component:() => import('@/components/pages/apps/platform_requests/Index.vue'),
            meta: {
                title: 'App Platform Requests',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Platform Requests', link: '/app_platform_requests'},
                ],
            }
        },
        {
            path: '/app_platform_requests/:id',
            name: 'app-platform-requests-detail',
            component:() => import('@/components/pages/apps/platform_requests/View.vue'),
            meta: {
                title: 'App Platform Requests detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'App Platform Requests', link: '/app_platform_requests' },
                    { name: 'App Platform requests detail' }
                ],
            }
        },
        {
            path: '/mkp_ship_push_logs',
            name: 'mkp-ship-push-logs',
            component:() => import('@/components/pages/apps/ship_push_log/Index.vue'),
            meta: {
                title: 'RTS Push Log',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'RTS Push Log', link: '/mkp_ship_push_logs'},
                ],
            }
        },
        {
            path: '/mkp_ship_push_logs/:id',
            name: 'mkp-ship-push-logs-detail',
            component:() => import('@/components/pages/apps/ship_push_log/View.vue'),
            meta: {
                title: 'RTS Push Log detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'RTS Push Log', link: '/mkp_ship_push_logs' },
                    { name: 'RTS Push Log detail' }
                ],
            }
        },
        /** ------------------- Router Orders ----------------------------- */
        {
            path: '/orders',
            component: () => import('@/components/pages/orders/Index.vue'),
            name: 'orders-list',
            meta: {
                title: 'Orders',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                ],
            },
        },
        {
            path: '/orders/incoming',
            component: () => import('@/components/pages/orders_incoming/Index.vue'),
            name: 'orders-incoming',
            meta: {
                title: 'Orders Incoming',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                    { name: 'Incoming Orders' },
                ],
            },
        },
        {
            path: '/orders/sync',
            component: () => import('@/components/pages/orders/SyncOrderNumbers.vue'),
            name: 'orders-sync',
            meta: {
                title: 'Sync Orders',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                    { name: 'Sync Orders' },
                ],
            },
        },
        {
            path: '/orders/push-v2',
            component: () => import('@/components/pages/orders/PushOrderV2.vue'),
            name: 'orders-push-v2',
            meta: {
                title: 'Push Order V2',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                    { name: 'Push Order V2' },
                ],
            },
        },
        {
            path: '/orders/shopee-ownfleet-import',
            component: () => import('@/components/pages/orders/ShopeeOwnfleetImport.vue'),
            name: 'orders-shopee-ownfleet-import',
            meta: {
                title: 'Shopee Own Fleet Import',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                    { name: 'Shopee Own Fleet Import' },
                ],
            },
        },
        {
            path: '/orders/:id',
            component: () => import('@/components/pages/orders/View.vue'),
            name: 'orders-view',
            meta: {
                title: 'Order View',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders' },
                    { name: 'Order detail'}
                ],
            }
        },
        {
            path: '/orders/detail/:order/:shop',
            component: () => import('@/components/pages/orders/ViewJson.vue'),
            name: 'orders-view-json',
            meta: {
                title: 'Order View Detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders/detail' },
                    { name: 'Json data'}
                ],
            }
        },
        {
            path: '/orders/json/:order',
            component: () => import('@/components/pages/orders/ViewJsonAll.vue'),
            name: 'orders-view-json-mongodb',
            meta: {
                title: 'Order View Detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders', link: '/orders/detail' },
                    { name: 'Json data'}
                ],
            }
        },
        /** ------------------- Router Order Verification ----------------------------- */
        {
            path: '/order-verification',
            component: () => import('@/components/pages/order_verification/Index.vue'),
            name: 'order-verification',
            meta: {
                title: 'Order Verification',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Order Verification', link: '/order-verification' },
                ],
            },
        },
        /** ------------------- Router Orders Match Status ----------------------------- */
        {
            path: '/orders-match-status',
            component: () => import('@/components/pages/orders_match_status/Index.vue'),
            name: 'orders-match-status-list',
            meta: {
                title: 'Orders Match Status',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Orders Match Status', link: '/orders-match-status' },
                ],
            },
        },
        /** ------------------- Router Products ----------------------------- */
        {
            path: '/products',
            component: () => import('@/components/pages/products/Index.vue'),
            name: 'products-list',
            meta: {
                title: 'Products',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Products'},
                ],
            }
        },
        {
            path: '/product/:id',
            component: () => import('@/components/pages/products/View.vue'),
            name: 'product-detail',
            meta: {
                title: 'Product log',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Products', link: '/products'},
                    { name: 'Product detail' }
                ],
                suffix: title_suffix,
            }
        },
        /** ------------------- Router For Buyers ----------------------------- */
        {
            path: '/buyers',
            component: () => import('@/components/pages/buyers/Index.vue'),
            name: 'buyers-list',
            meta: {
                title: 'Buyers',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Buyers'},
                ],
            }
        },
        {
            path: '/buyers/:id',
            component: () => import('@/components/pages/buyers/View.vue'),
            name: 'buyers-detail',
            meta: {
                title: 'Buyer detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Buyers', link: '/buyers'},
                    { name: 'Buyer detail' }
                ],
            }
        },
        /** ------------------- Router For Shops ---------------------------- */
        {
            path: '/shops',
            component: () => import('@/components/pages/shops/Index.vue'),
            name: 'shops-list',
            meta: {
                title: 'Shops',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shops'},
                ],
            }
        },
        {
            path: '/shops/:id',
            component: () => import('@/components/pages/shops/View.vue'),
            name: 'shop-detail',
            meta: {
                title: 'Shop Detail',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Shops', link: '/shops'},
                    { name: 'Detail' }
                ],
                suffix: title_suffix,
            }
        },
        {
            path: '/products/platform/:shop/:product',
            component: () => import('@/components/pages/shops/productseller/ViewJson.vue'),
            name: 'productseller-view-json',
            meta: {
                title: 'Product Seller View Detail',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shops', link: '/shops/product' },
                    { name: 'Json data'}
                ],
            }
        },
        /** ------------------- Router For Shipment -------------------------- */
        {
            path: '/shipments',
            component: () => import('@/components/pages/shipments/Index.vue'),
            name: 'shipments-list',
            meta: {
                title: 'Shipments',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shipment'},
                ],
            }
        },
        {
            path: '/shipments/:id',
            component: () => import('@/components/pages/shipments/View.vue'),
            name: 'shipments-detail',
            meta: {
                title: 'Shipments log',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Shipments', link: '/shipments'},
                    { name: 'Detail' }
                ],
                suffix: title_suffix,
            }
        },
        /** ------------------- Router For Shipment Logs -------------------------- */
        {
            path: '/shipments_log',
            name: 'shipments-log',
            component:() => import('@/components/pages/shipments_log/Index.vue'),
            meta: {
                title: 'Shipments Log',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shipments Log', link: '/shipments_log'},
                ],
            }
        },
        // {
        //     path: '/shipments_log',
        //     component: () => import('@/components/pages/shipments_log/Index.vue'),
        //     name: 'shipments-log',
        //     meta: {
        //         title: 'Shipments Log',
        //         layout: 'admin-layout',
        //         suffix: title_suffix,
        //         breadcrumb: [
        //             { name: 'Shipment-log'},
        //         ],
        //     }
        // },
        /** ------------------- Router Shipment Labels ----------------------------- */
        {
            path: '/shipment_labels',
            component: () => import('@/components/pages/shipment_labels/Index.vue'),
            name: 'shipment-lables-list',
            meta: {
                title: 'Shipment Labels',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shipment labels', link: '/shipment_labels' },
                ],
            },
        },
        {
            path: '/shipment_labels/:id',
            component: () => import('@/components/pages/shipment_labels/View.vue'),
            name: 'shipment-labels-view',
            meta: {
                title: 'Shipment Labels View',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Shipment Labels', link: '/shipment_labels' },
                    { name: 'Shipment Labels detail'}
                ],
            }
        },
        /** ------------------- Router For Webhook ----------------------------- */
        {
            path: '/platform_requests',
            component: () => import('@/components/pages/platform_requests/Index.vue'),
            meta: {
                title: 'Platforms request',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Platforms Request' }
                ],
            }
        },
        /** ------------------- Router Movements ----------------------------- */
        {
            path: '/movements',
            component: () => import('@/components/pages/movements/Index.vue'),
            name: 'movements-list',
            meta: {
                title: 'Movements',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Movements'},
                ],
            }
        },
        /** ------------------- Router Product Link ----------------------------- */
        {
            path: '/product-link',
            component: () => import('@/components/pages/product_link/Index.vue'),
            name: 'product-link',
            meta: {
                title: 'Product Link',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Product Link'},
                ],
            }
        },
        {
            path: '/product-link/:id',
            component: () => import('@/components/pages/product_link/View.vue'),
            name: 'product-link-detail',
            meta: {
                title: 'Product Link Detail',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Product link', link: '/product-link'},
                    { name: 'Product Link Detail' }
                ],
                suffix: title_suffix,
            }
        },
        /** ------------------- Router Announcements ----------------------------- */
        {
            path: '/announcements',
            component: () => import('@/components/pages/announcements/Index.vue'),
            name: 'announcements',
            meta: {
                title: 'Marketplace Announcements',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Announcements'},
                ],
            }
        },
        /** ------------------- Router Documents ----------------------------- */
        {
            path: '/documents',
            component: () => import('@/components/pages/documents/Index.vue'),
            name: 'documents',
            meta: {
                title: 'Marketplace Documentation',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Documents'},
                ],
            }
        },
        {
            path: '/tools/product',
            component: () => import('@/components/pages/tools/products/Index.vue'),
            name: 'tools-listing-index',
            meta: {
                title: 'Product list',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Tools', link: '/'},
                    { name: 'Proudct Listing' }
                ],
                suffix: title_suffix,
            }
        },
        {
            path: '/tools/product/create',
            component: () => import('@/components/pages/tools/products/Create_update.vue'),
            name: 'tools-listing-create',
            meta: {
                title: 'Product create',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Tools', link: '/'},
                    { name: 'Proudct Listing' }
                ],
                suffix: title_suffix,
            }
        },
        {
            path: '/tools/product/edit/:id',
            component: () => import('@/components/pages/tools/products/Create_update.vue'),
            name: 'tools-listing-edit',
            meta: {
                title: 'Product create',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Tools', link: '/'},
                    { name: 'Proudct Listing' }
                ],
                suffix: title_suffix,
            }
        },
        {
            path: '/tools/platform-api',
            component: () => import('@/components/pages/tools/platform-api/Index.vue'),
            name: 'tools-platform-api',
            meta: {
                title: 'Platform API Tool',
                layout: 'admin-layout',
                breadcrumb: [
                    { name: 'Tools', link: '/'},
                    { name: 'Platform API Tool' }
                ],
                suffix: title_suffix,
            }
        },
        /** ------------------- Router Users ----------------------------- */
        {
            path: '/users',
            component: () => import('@/components/pages/users/Index.vue'),
            name: 'users-list',
            meta: {
                title: 'Users',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Users'},
                ],
            }
        },
        /** ------------------- Router Reservations ----------------------------- */
        ...(RESERVATIONS_ENABLED ? [
            {
                path: '/reservations',
                name: 'reservations-list',
                component: () => import('@/components/pages/reservations/Index.vue'),
                meta: {
                    title: 'Reservations',
                    layout: 'admin-layout',
                    suffix: title_suffix,
                    breadcrumb: [
                        { name: 'Reservations' }
                    ],
                    requiresDevDba: true,
                },
            },
            {
                path: '/reservations/products',
                name: 'reservations-products',
                component: () => import('@/components/pages/reservations_products/Index.vue'),
                meta: {
                    title: 'Reservations by Product',
                    layout: 'admin-layout',
                    suffix: title_suffix,
                    breadcrumb: [
                        { name: 'Reservations', link: '/reservations' },
                        { name: 'By Product' }
                    ],
                    requiresDevDba: true,
                },
            },
            {
                path: '/reservations/reconcile',
                name: 'reservations-reconcile',
                component: () => import('@/components/pages/reservations_reconcile/Index.vue'),
                meta: {
                    title: 'Stuck Reserves',
                    layout: 'admin-layout',
                    suffix: title_suffix,
                    breadcrumb: [
                        { name: 'Reservations', link: '/reservations' },
                        { name: 'Stuck Reserves' }
                    ],
                    requiresDevDba: true,
                },
            },
        ] : []),
        /** ------------------- Router Manual Marketplace Order Sync (M22 — feature 00016) ----------------------------- */
        {
            path: '/manual-sync',
            name: 'manual-sync',
            component: () => import('@/components/pages/manual_sync/Index.vue'),
            meta: {
                title: 'Manual Marketplace Sync',
                layout: 'admin-layout',
                suffix: title_suffix,
                breadcrumb: [
                    { name: 'Manual Marketplace Sync' }
                ],
            },
        },
        /** ------------------- Login / Catch 404 ----------------------------- */
        {
            path: '/login',
            component: () => import('@/components/pages/auth/Login.vue'),
            name: 'login',
            meta: {
                title: "Login",
                layout: "authorization-layout",
                suffix: title_suffix
            },
        },
        {
            path: "/:catchAll(.*)",
            name: "Not Found",
            component: () => import("@/components/pages/404.vue"),
            meta: {
                title: "Not found",
                icon: "",
                breadcrumb: [{ name: "Not Found" }],
            },
        },
    ]
})

export default router